import {
  useAddressStore,
  useAssortmentStore,
  useBreadcrumbStore,
  useCampaignStore,
  useCartStore,
  useContentStore,
  useDeliveryStore,
  useListStore,
  useMenuStore,
  useOrderStore,
  useProductStore,
  useServerStore,
  useStoresStore,
  useTrackingStore,
  useUiStore,
  useUserStore,
  useUsersStore,
} from '~/stores';

declare global {
  interface Window {
    Cypress?: any;
    $nuxt?: {
      $on?: (...args: any[]) => void;
    };
    store: { [key: string]: any };
  }
}

export default defineNuxtPlugin(() => {
  if (!process.server) {
    // // Temporary fix for kundo type error
    window.$nuxt = {
      $on: () => {},
    };

    if (window.Cypress) {
      const addressStore = useAddressStore();
      const assortmentStore = useAssortmentStore();
      const breadcrumbStore = useBreadcrumbStore();
      const campaignStore = useCampaignStore();
      const cartStore = useCartStore();
      const deliveryStore = useDeliveryStore();
      const contentStore = useContentStore();
      const listStore = useListStore();
      const menuStore = useMenuStore();
      const orderStore = useOrderStore();
      const productStore = useProductStore();
      const serverStore = useServerStore();
      const storesStore = useStoresStore();
      const trackingStore = useTrackingStore();
      const uiStore = useUiStore();
      const userStore = useUserStore();
      const usersStore = useUsersStore();
      window.store = {
        addressStore,
        assortmentStore,
        breadcrumbStore,
        campaignStore,
        cartStore,
        deliveryStore,
        contentStore,
        listStore,
        menuStore,
        orderStore,
        productStore,
        serverStore,
        storesStore,
        trackingStore,
        uiStore,
        userStore,
        usersStore,
      };
    }
  }
});
